<template>
  <v-container>
    <v-row>
      <v-col>
        <v-img
          max-height="200"
          contain
          src="https://kuzee.x10spin.com/uploads/cache/resize/cede035f934852a1f914483b7eb8ed7b/58bd27c2d74cf.png"
        >
        </v-img>
      </v-col>
      <v-spacer></v-spacer>
      <v-col align-self="center">
        <div class="text-center">
          <v-menu offset-y :open-on-hover="!this.$vuetify.breakpoint.xs">
            <template v-slot:activator="{ on }">
              <v-btn text color="primary" dark v-on="on">
                Info<v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in infoItems"
                :key="index"
                @click="navItemOnClick(item)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <ConditionsDialog
      v-model="conditionsDialog"
      :init_tab="conditionsDialogInitTab"
    ></ConditionsDialog>
  </v-container>
</template>

<script>
import ConditionsDialog from "../../../../components/views/ConditionsDialog";
export default {
  name: "AppBar",
  components: { ConditionsDialog },
  data() {
    return {
      infoItems: [
        { title: "Gebruikers voorwaarden", action: "CONDITIONS" },
        { title: "Privacy verklaring", action: "PRIVACY" }
      ],
      actions: {
        privacy: "PRIVACY",
        conditions: "CONDITIONS"
      },
      conditionsDialogInitTab: 0,
      conditionsDialog: false
    };
  },
  methods: {
    navItemOnClick(item) {
      switch (item.action) {
        case this.actions.conditions:
          this.conditionsDialogInitTab = 0;
          break;
        case this.actions.privacy:
          this.conditionsDialogInitTab = 1;
          break;
      }
      this.conditionsDialog = true;
    }
  }
};
</script>

<style scoped></style>
